import Papa from 'papaparse';

const normalize = (value) => String(value).trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
const aliases = [['codigo', 'code'], ['titulo', 'title', 'descricao'], ['valor', 'price', 'preco']];

export function parseCsvText(text) {
  const result = Papa.parse(text, { skipEmptyLines: 'greedy' });
  if (result.errors.length) throw new Error('CSV inválido: confira os separadores e as aspas do arquivo.');
  const rows = result.data;
  if (!rows.length) throw new Error('O arquivo não contém procedimentos.');
  const header = rows[0].map(normalize);
  const columns = aliases.map((names) => header.findIndex((name) => names.includes(name)));
  const hasHeader = columns.some((index) => index >= 0);
  if (hasHeader && columns.some((index) => index < 0)) {
    throw new Error('O cabeçalho deve conter código, título e valor.');
  }
  const indexes = hasHeader ? columns : [0, 1, 2];
  const codes = new Set();
  const items = rows.slice(hasHeader ? 1 : 0).map((row, index) => {
    const line = index + (hasHeader ? 2 : 1);
    const [codigo, titulo, raw] = indexes.map((column) => String(row[column] ?? '').trim());
    if (row.length !== rows[0].length || (!hasHeader && row.length !== 3)) {
      throw new Error(`Registro ${line}: quantidade de colunas inválida.`);
    }
    if (!codigo || !titulo) throw new Error(`Registro ${line}: código e título são obrigatórios.`);
    const amount = raw.replace(/^R\$\s*/, '');
    const valid = /^(?:\d+|\d{1,3}(?:\.\d{3})+),\d{1,2}$/.test(amount) || /^\d+(?:\.\d{1,2})?$/.test(amount);
    const valor = Number(amount.includes(',') ? amount.replace(/\./g, '').replace(',', '.') : amount);
    if (!valid || !Number.isFinite(valor)) throw new Error(`Registro ${line}: valor inválido (${raw || 'vazio'}).`);
    if (codes.has(codigo)) throw new Error(`Registro ${line}: código duplicado (${codigo}).`);
    codes.add(codigo);
    return { codigo, titulo, valor };
  });
  if (!items.length) throw new Error('O arquivo não contém procedimentos.');
  return items;
}
